const service = require('@/assets/js/request')
class phoneLogin {
  /**
   * 注册
   */
  static verify (target) {
    service.request({
      method: 'POST',
      url: 'verify'
    }).then(res => {
      if (res.code === '2001') {
        target.codeimg = res.data.base64
        target.key = res.data.key
        console.log(target.codeimg)
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }

  /**
   * 注册
   */
  static register (target) {
    service.request({
      method: 'POST',
      url: 'register',
      params: {
        username: target.username,
        password: target.password,
        code: target.code,
        key: target.key
      }
    }).then(res => {
      if (res.code === '2001') {
        if (res.data) {
          target.$message({
            message: res.msg,
            type: 'success'
          })
          setTimeout(() => {
            target.setLoginMode()
          }, 1000)
        }
      } else {
        target.$message({
          message: res.msg,
          type: 'warning'
        })
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default phoneLogin



// WEBPACK FOOTER //
// ./src/components/login/register/register.js